import { render, staticRenderFns } from "./SavedBy.vue?vue&type=template&id=39960a1a&scoped=true"
import script from "./SavedBy.vue?vue&type=script&lang=js"
export * from "./SavedBy.vue?vue&type=script&lang=js"
import style0 from "./SavedBy.vue?vue&type=style&index=0&id=39960a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39960a1a",
  null
  
)

export default component.exports